import { CameraOutlinedIcon } from '@village/icons';
import { Props as BannerProps } from 'components/banner';
import { FC, ReactNode, Fragment } from 'react';

import * as Styled from './styles';

interface Props extends BannerProps {
    subtitle?: ReactNode;
    handleClick: () => void;
}

export const SwitchToVideoBannerBottom: FC<Props> = ({
    variant = 'default',
    status = 'visit_type',
    handleClick,
    ...bannerProps
}) => (
    <Styled.Banner data-testid="visit-type-banner" variant={variant} iconSize={1.5} status={status} {...bannerProps} icon={null}>
        {
            <Fragment>
                <Styled.Title type="h6">Need to be seen sooner?</Styled.Title>
                <Styled.Content type="body1" data-testid="visit-type-banner-subtitle">
                    We&apos;ve expanded virtual care options to better serve you.
                </Styled.Content>
                <Styled.ButtonWrapper>
                    <Styled.Button
                        onClick={handleClick}
                        size="small"
                        variant="secondary"
                        data-testid="switch-to-video-button"
                        startIcon={<CameraOutlinedIcon />}
                    >
                        View video visits
                    </Styled.Button>
                </Styled.ButtonWrapper>
            </Fragment>
        }
    </Styled.Banner>
);
